import axios from "axios";

// Call our Vercel serverless function instead of OpenAI directly
export const calculateTokensWithAI = async (
  prompt: string,
  model: string = "gpt-3.5-turbo"
) => {
  const response = await axios.post("/api/calculate-tokens", {
    prompt,
    model,
  });
  return response.data;
};

// Call our Vercel serverless function instead of OpenAI directly
export const getProviderRecommendation = async (formData: {
  productDescription: string;
  userType: string;
  features: string;
  traffic: string;
  compliance: string;
  budgetSensitivity: string;
}) => {
  const response = await axios.post("/api/provider-recommendation", formData);
  return response.data;
};
